//This file is automatically rebuilt by the Cesium build process.
export default "vec4 czm_computePosition();\n\
";
